import { Injectable } from '@angular/core';
import { ServerService } from './ServerService';
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ServidorImpressaoService extends ServerService {
 private computadoIndentificacaorUtils: ComputadorIdentificacaoUtils;
 constructor(http: HttpClient) {
   super(http);
   this.computadoIndentificacaorUtils =  new ComputadorIdentificacaoUtils();
 }

  listeServidores(): Promise<any[]> {
    return this.obtenha('/servidores-impressao', {});
  }

  obtenhaServidor(id: number): Promise<any> {
    return this.obtenha(`/servidores-impressao/${id}`, {});
  }

  salveServidor(servidorImpressao: any): Promise<any> {
    return new Promise<any>( async (resolve, reject) => {
      if(!servidorImpressao.id){ //salva e registra ocmo servidor
        let resp: any = await this.facaPost(`/servidores-impressao`, servidorImpressao).catch((err) => {
          reject(err)
        });

        if(resp ){
          this.computadoIndentificacaorUtils.registreServidorImpressao(resp)
          resolve(resp)
        }
      } else {
        return  this.facaPut(`/servidores-impressao/${servidorImpressao.id}`, servidorImpressao);
      }
    })
  }

  removaServidor(servidorId: number): Promise<any> {
    return new Promise<any>( async (resolve, reject) => {
      let resp: any = await   this.remova(`/servidores-impressao/${servidorId}`, {}).catch((err) => {
        reject(err)
      });

      if(resp){
        this.computadoIndentificacaorUtils.removaServidorImpressao()
        resolve(resp)
      }
    })

  }


  getIdentificacaoMaquina(){
    return  this.computadoIndentificacaorUtils.getComputadorId();
  }


  atualizeAtividade(servidorId: number): Promise<any> {
    return this.facaPost(`/servidores-impressao/${servidorId}/heartbeat`, {});
  }

  desativeServidor(servidorId: number): Promise<any> {
    return this.facaPost(`/servidores-impressao/${servidorId}/desativar`, {});
  }



  // Método para verificar se este computador é o servidor configurado
  async verificarSeServidorConfigurado(): Promise<boolean> {
    return this.computadoIndentificacaorUtils.ehComutadorRegistrado();
  }

  async getServidorRegistrado(){
    return this.computadoIndentificacaorUtils.getServidorRegistrado();
  }
}

class ComputadorIdentificacaoUtils {
  // Identificadores únicos do computador
  private computadorId: string;
  private hostname: string;
  private ipLocal: string;

  constructor() {
    this.identificarComputador();
  }

  private identificarComputador(): void {
    // Hostname do computador
    this.hostname = window.location.hostname || 'localhost';

    // Gerar ID único baseado em características do computador
    this.computadorId = this.gerarIdUnico();

    // IP local (se disponível)
    this.ipLocal = this.obterIpLocal();
  }

  private gerarIdUnico(): string {
    // Combinar múltiplas características para criar um ID único
    const caracteristicas = [
      this.hostname,
      navigator.userAgent,
      screen.width + 'x' + screen.height,
      new Date().getTimezoneOffset().toString()
    ];

    // Hash simples das características
    let hash: any = 0;
    const str = caracteristicas.join('|');
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      // tslint:disable-next-line:no-bitwise
      hash = ((hash << 5) - hash) + char;
      // tslint:disable-next-line:no-bitwise
      hash = hash & hash; // Convert to 32bit integer
    }

    return `${this.hostname}:${Math.abs(hash)}`;
  }

  private obterIpLocal(): string {
    // Em um ambiente real, você pode usar WebRTC ou outras técnicas
    // Por enquanto, retornamos o hostname
    return this.hostname;
  }

  // Métodos públicos para obter informações do computador
  getComputadorId(): string {
    return this.computadorId;
  }

  //todo: alterar isso depois,nao precisar ser igual salvo baster esta registrado
  async ehComutadorRegistrado(){
     let servidorSalvo: any = await this.getServidorRegistrado();

     return servidorSalvo && servidorSalvo.computadorId === this.computadorId
  }

  removaServidorImpressao(){
    localStorage.removeItem('mcisrvid')
  }

  // Método para configurar este computador como servidor
  registreServidorImpressao(servidor: any){
    try {
      servidor.horario  = new Date().getTime();
      localStorage.setItem('mcisrvid', JSON.stringify(servidor))
    } catch (erro) {
      console.error('Erro ao configurar como servidor:', erro);
    }
  }

  async getServidorRegistrado(): Promise<any>{
    return new Promise(async (resolve) => {
      try{
        let dados =  localStorage.getItem('mcisrvid');

        if(dados) return resolve(JSON.parse(dados));

      } catch (erro) {
        console.error('Erro ao obtter dadso servidor:', erro);
        return null;
      }

      const response = await fetch('/servidores-impressao/computadorid/' + this.computadorId);

      if (!response.ok)
        return resolve(null)

      const data = await response.json();

      //limpou o locastorage, salve novamente
      if(data && data.id){
        this.registreServidorImpressao(data)
        resolve(data)
      } else {
        resolve(null)
      }
    })

  }
}
